module.exports = __webpack_public_path__ + "img/hangzhou_door.3432d321.jpg";